import { useTranslation } from "react-i18next";
import { Award } from "lucide-react";

export function TierBanner({ tierInfo }) {
  const { t } = useTranslation();
  return (
    <div data-testid="client-tier" className="mb-8 rounded-2xl border border-border bg-white p-5 flex items-center gap-4">
      <div className={`w-12 h-12 rounded-full flex items-center justify-center shrink-0 ${tierInfo.tier === "or" ? "bg-yellow-100 text-yellow-700" : tierInfo.tier === "argent" ? "bg-slate-200 text-slate-600" : "bg-amber-100 text-amber-700"}`}><Award className="w-6 h-6" /></div>
      <div className="flex-1">
        <p className="text-xs uppercase font-bold text-muted2 tracking-wide">{t("tier.title")}</p>
        <p className="font-heading font-extrabold text-xl text-ink" data-testid="client-tier-name">{t(`tier.${tierInfo.tier}`)}</p>
        <p className="text-xs text-muted2 mt-0.5">{t("tier.perk", { mult: tierInfo.multiplier })} · {tierInfo.next_threshold ? t("tier.next", { n: Math.max(0, tierInfo.next_threshold - tierInfo.completed_bookings) }) : t("tier.max")}</p>
        {tierInfo.discount_pct > 0 && <p className="text-xs font-bold text-emeraude-dark mt-1" data-testid="client-tier-discount">{t("tier.discount", { pct: tierInfo.discount_pct })}</p>}
      </div>
    </div>
  );
}
